import React from 'react';
import { nanoid } from 'nanoid';
import { Container } from 'react-bootstrap';
import HomePage from '../../Components/HomePage';

import './styles.css';

const HomeLanding = () => {
  return (
    <Container fluid className="p-0" key={nanoid()}>
      <HomePage />
    </Container>
  );
};
export default React.memo(HomeLanding);
